import { styled } from 'styled-components';
import Typography from '../../../../Typography/index.js';
export const Wrapper = styled.div `
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px 8px;
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};
  color: ${({ theme, $active }) => ($active ? theme.colors.main : theme.colors.grey100_1)};
  ${({ theme }) => theme.typography.weightMedium}

  &:hover {
    color: ${({ theme, $active }) => !$active && theme.colors.black_1};
  }
`;
export const Title = styled(Typography.TextMedium) `
  display: flex;
  white-space: nowrap;
`;
